import {GameJackpotBarLogoMrgreenBox} from "./game-jackpot-bar-logo.mrgreen.box";

export const GameJackpotBarLogoMrgreenCisBox = GameJackpotBarLogoMrgreenBox;